<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>call_received</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>Alta de Quita</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row v-if="!selectedPersona" dense>
            <v-col>
              <span>Seleccione a una Persona</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="!selectedPersona">
            <v-col cols="12">
              <app-busqueda-personas
                :personaSeleccionada="setPersona"
              ></app-busqueda-personas>
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-col>
              <span>Persona seleccionada</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="selectedPersona">
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.cui"
                label="CUI(L/T) "
                key="cuil"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.nombreCompleto"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="warning" small text @click="limpiar"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>
          <!-- lista de deudas de la persona -->
          <v-container fluid v-if="selectedPersona">
            <v-card>
              <v-card-title>
                <span class="title">Deudas Actuales</span>
              </v-card-title>

              <v-row>
                <v-col>
                  <v-card flat>
                    <v-card-title>
                      <span v-if="!loadingDeudas">Créditos con Deuda</span>
                      <span v-if="loadingDeudas" class="green--text">
                        (Consultando Deudas de la Persona...
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="green"
                        ></v-progress-circular
                        >)</span
                      >
                    </v-card-title>

                    <!-- créditos con deuda -->
                    <v-container fluid v-if="listDeudas.length > 0">
                      <v-row class="body-2">
                        <v-col> Crédito </v-col>
                        <v-col> Deuda a la Fecha </v-col>
                      </v-row>
                      <v-switch v-model="esBotonDeArrepentimiento" label="Es por Arrepentimiento"></v-switch>
                      <v-divider></v-divider>

                      <template v-for="(item, index) in listDeudas">
                        <v-row :key="index">
                          <v-container fluid>
                            <v-row class="caption" no-gutters>
                              <v-col>
                                Nº {{ item.numero }}, de {{ item.origen }}
                              </v-col>
                              <v-col>
                                {{ item.deudaALaFecha }}
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-btn
                                  small
                                  text
                                  color="green"
                                  @click="
                                    creditoSeleccionadoId = item.id;
                                    showDetalleCredito = true;
                                  "
                                >
                                  Realizar Quita sobre este Crédito
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-divider pa-6></v-divider>
                          </v-container>
                        </v-row>
                      </template>
                    </v-container>

                    <v-card-actions>
                      <v-row v-if="selectedPersona && creditoSeleccionado">
                        <v-col>
                          <v-radio-group
                            v-model="realizarQuitaPor"
                            row
                            :mandatory="true"
                          >
                            <v-radio
                              value="cuota"
                              label="Realizar Quita por Cuotas"
                            ></v-radio>
                            <v-radio
                              value="importe"
                              label="Realizar Quita por Importe"
                            ></v-radio>
                            <v-radio
                              value="punitorios"
                              label="Realizar Quita de Punitorios"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>

                  <v-card
                    v-if="realizarQuitaPor == 'cuota' && creditoSeleccionado"
                    flat
                  >
                    <v-card-title>
                      <span
                        >Seleccione las Cuotas sobre las cuales realizar la
                        Quita</span
                      >
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-container>
                            <v-card outlined>
                              <v-card-text>
                                <v-row>
                                  <v-col>
                                    <span
                                      class="caption blue--text font-weight-medium"
                                      >Detalle de Deuda del Crédito Nº
                                      {{ creditoSeleccionado.numero }}</span
                                    >
                                  </v-col>
                                </v-row>
                                <v-row no-gutters>
                                  <v-col cols="3">
                                    <span class="caption">Cuota</span>
                                  </v-col>
                                  <v-col cols="2">
                                    <span class="caption">Saldo Cta.</span>
                                  </v-col>
                                  <v-col cols="2">
                                    <span class="caption">Punitorios</span>
                                  </v-col>
                                  <v-col cols="2">
                                    <span class="caption">Cargos</span>
                                  </v-col>
                                  <v-col cols="2">
                                    <span class="caption">Saldo Total</span>
                                  </v-col>

                                  <v-col cols="1">
                                    <span class="caption"></span>
                                  </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <template
                                  v-for="(
                                    subitem, subindex
                                  ) in creditoSeleccionado.detalle"
                                >
                                  <v-row :key="subindex" no-gutters>
                                    <v-col cols="3">
                                      <div
                                        v-if="subitem.vencido"
                                        class="caption red--text"
                                      >
                                        Nº {{ subitem.numero }}, Vto.
                                        {{
                                          subitem.vencimiento
                                            | dateParse()
                                            | dateFormat('DD-MM-YY')
                                        }}
                                      </div>
                                      <div v-else class="caption">
                                        Nº {{ subitem.numero }}, Vto.
                                        {{
                                          subitem.vencimiento
                                            | dateParse()
                                            | dateFormat('DD-MM-YY')
                                        }}
                                      </div>
                                    </v-col>
                                    <v-col cols="2">
                                      <div
                                        v-if="subitem.vencido"
                                        class="caption red--text"
                                      >
                                        {{ subitem.importeCuota | currency }}
                                      </div>
                                      <div v-else class="caption">
                                        {{ subitem.importeCuota | currency }}
                                      </div>
                                    </v-col>
                                    <v-col cols="2">
                                      <div
                                        v-if="subitem.vencido"
                                        class="caption red--text"
                                      >
                                        {{
                                          subitem.importePunitorios | currency
                                        }}
                                      </div>
                                      <div v-else class="caption">
                                        {{
                                          subitem.importePunitorios | currency
                                        }}
                                      </div>
                                    </v-col>
                                    <v-col cols="2">
                                      <div
                                        v-if="subitem.vencido"
                                        class="caption red--text"
                                      >
                                        {{ subitem.importeCargos | currency }}
                                      </div>
                                      <div v-else class="caption">
                                        {{ subitem.importeCargos | currency }}
                                      </div>
                                    </v-col>
                                    <v-col cols="2">
                                      <div
                                        v-if="subitem.vencido"
                                        class="caption red--text"
                                      >
                                        {{ subitem.importeTotal | currency }}
                                      </div>
                                      <div v-else class="caption">
                                        {{ subitem.importeTotal | currency }}
                                      </div>
                                    </v-col>
                                    <v-col cols="1">
                                      <div class="caption">
                                        <v-icon
                                          v-if="
                                            listDeudasABonificar.find(
                                              (i) => i.cuotaId == subitem.id
                                            ) == null
                                          "
                                          color="green"
                                          @click="
                                            agregarCuotaCredito(
                                              creditoSeleccionado.id,
                                              subitem
                                            )
                                          "
                                          >add</v-icon
                                        >
                                        <v-icon
                                          v-else
                                          color="green"
                                          @click="
                                            quitarCuota(
                                              creditoSeleccionado.id,
                                              subitem
                                            )
                                          "
                                          >remove</v-icon
                                        >
                                      </div>
                                    </v-col>
                                  </v-row>
                                </template>
                              </v-card-text>
                            </v-card>
                          </v-container>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="
                      creditoSeleccionadoId && realizarQuitaPor == 'importe'
                    "
                    flat
                  >
                    <v-card-title>
                      <span>Aplicar Quita a</span>
                    </v-card-title>
                    <v-card-text>
                      <v-row
                        v-if="
                          creditoSeleccionadoId && realizarQuitaPor == 'importe'
                        "
                      >
                        <v-container>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                label="Capital"
                                v-model="aplicacionCapital"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                label="Interés"
                                v-model="aplicacionInteres"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                label="Cargos 1"
                                v-model="aplicacionCargo1"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                label="Cargos 2"
                                v-model="aplicacionCargo2"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                label="Cargos 3"
                                v-model="aplicacionCargo3"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                label="Cargos 3"
                                v-model="aplicacionCargo4"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                label="Cargos 5"
                                v-model="aplicacionCargo5"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                disabled
                                label="Total a Aplicar"
                                v-model="totalAAplicar"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col> </v-col>
                            <v-spacer></v-spacer>
                            <v-col>
                              <v-btn
                                small
                                color="success"
                                @click="validarQuitaPorImporte()"
                              >
                                Validar Aplicación
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card
                    v-if="
                      creditoSeleccionadoId && realizarQuitaPor == 'punitorios'
                    "
                    flat
                  >
                    <v-card-title>
                      <span>Condonación de Saldos de Puntorios</span>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-data-table
                          fixed-header
                          :headers="headersCuentaPunitorios"
                          :items="cuentaPunitorios"
                          :loading="loading"
                          loading-text="Cargando Cuenta de Punitorios..."
                          dense
                        >
                          <template v-slot:no-data>
                            No se encontraron datos
                          </template>

                          <template v-slot:item="{ item }">
                            <tr>
                              <td
                                v-if="item.tipo == 'CUOTA'"
                                class="text-xs-left caption orange"
                              >
                                {{ item.fecha | formatDate }}
                              </td>
                              <td v-else class="text-xs-left caption">
                                {{ item.fecha | formatDate }}
                              </td>

                              <td class="text-xs-left caption">
                                <tr v-if="item.tipo == 'PAGO'">
                                  Pago Cuota Nº
                                  {{
                                    item.cuota
                                  }}
                                </tr>
                                <tr v-if="item.tipo == 'CUOTA'">
                                  Cuota Nº
                                  {{
                                    item.cuota
                                  }}
                                </tr>
                                <tr v-if="item.tipo == 'QUITA'">
                                  Quita Cuota Nº
                                  {{
                                    item.cuota
                                  }}
                                </tr>
                              </td>

                              <td class="text-xs-right caption">
                                {{ item.importe | currency }}
                              </td>
                              <td
                                class="text-xs-right caption"
                                v-if="item.tipo == 'CUOTA'"
                              >
                                {{ item.saldo | currency }}
                              </td>
                              <td class="text-xs-right caption" v-else></td>
                              <td class="text-xs-left caption">
                                {{ item.masDatos }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-row>

                      <v-row
                        v-if="
                          creditoSeleccionadoId &&
                          realizarQuitaPor == 'punitorios'
                        "
                      >
                        <v-container>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field
                                label="Punitorios a Condonar"
                                v-model="aplicacionPunitorios"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field
                                disabled
                                label="Total a Aplicar"
                                v-model="totalAAplicar"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col> </v-col>
                            <v-spacer></v-spacer>
                            <v-col>
                              <v-btn
                                small
                                color="success"
                                @click="validarQuitaPorImporte()"
                              >
                                Validar Aplicación
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-container>

          <v-container>
            <v-card v-if="selectedPersona && listDeudasABonificar.length > 0">
              <v-card-title>
                <span class="title">Resumen de Conceptos a Bonificar</span>
              </v-card-title>
              <v-card-text>
                <v-row class="caption" no-gutters>
                  <v-col cols="9" class="font-weight-bold">Detalle</v-col>
                  <v-col cols="3" class="text-right font-weight-bold"
                    >Importe</v-col
                  >
                  <!-- <v-col cols="1" class="text-right font-weight-bold"></v-col> -->
                </v-row>
                <template v-for="(item, index) in listDeudasABonificar">
                  <v-row class="caption" no-gutters :key="index">
                    <v-col cols="9">
                      <span class="caption"
                        >- Cta. Nº {{ item.item.cuota }}, Vto.
                        {{
                          item.item.vencimiento
                            | dateParse()
                            | dateFormat('MM/YY')
                        }}
                        del Cred. Nº
                        <span class="font-italic font-weight-medium">
                          {{ item.numero }}
                        </span></span
                      >
                    </v-col>
                    <v-col cols="3"
                      ><div class="text-right">
                        {{ item.totalAAplicar | currency }}
                      </div></v-col
                    >
                    <!-- <v-col cols="1"><div class="text-right" ><v-icon color="red" small @click="quitarCuota(item)">clear</v-icon></div></v-col> -->
                  </v-row>
                </template>
                <v-divider></v-divider>
                <v-row class="caption" no-gutters>
                  <v-col cols="9" class="text-center font-weight-bold"
                    >TOTAL</v-col
                  >
                  <v-col cols="3" class="text-right font-weight-bold">{{
                    totalABonificar | currency
                  }}</v-col>
                  <!-- <v-col cols="1" class="text-right font-weight-bold"></v-col> -->
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn v-if="listDeudasABonificar.length >0" color="green" small dark @click="altaNotaCredito">Realizar Quita </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-container>

          <span v-if="creditoSeleccionadoId">
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="sucursalId"
                  :items="sucursales"
                  item-text="nombre"
                  item-value="id"
                  label="Sucursal:"
                  placeholder="Seleccione una"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="fecha"
                  label="Fecha del Comprobante"
                  type="date"
                  prepend-icon="event"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="comentarios"
                  class="mx-2"
                  label="Comentarios Adicionales"
                  prepend-icon="comment"
                  clearable
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </span>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="altaNotaCredito"
          :disabled="saving"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>
      {{ listDeudasABonificar }}
      CreditoSeleccionado: {{ creditoSeleccionadoId }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { addDays, format } from 'date-fns';
//import {Decimal} from 'decimal.js';

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    saving: false,
    selectedPersona: null,
    listDeudas: [],
    listDeudasABonificar: [],
    fecha: format(new Date(), 'YYYY-MM-DD'),
    showDetalleCredito: false,
    creditoSeleccionadoId: null,
    aplicacionCapital: null,
    aplicacionInteres: null,
    aplicacionCargo1: null,
    aplicacionCargo2: null,
    aplicacionCargo3: null,
    aplicacionCargo4: null,
    aplicacionCargo5: null,
    aplicacionPunitorios: null,
    sucursales: [],
    sucursalId: 0,
    comentarios: '',
    realizarQuitaPor: '',
    esBotonDeArrepentimiento: false,
    headersCuentaPunitorios: [
      // definición de columnas
      { text: 'Fecha', value: 'fecha', width: 100 },
      { text: 'Concepto', value: 'concepto', width: 200 },
      { text: 'Importe', value: 'importe', width: 120 },
      { text: 'Saldo', value: 'saldo', width: 120 },
      { text: 'Motivo', value: 'masDatos' },
    ],
    cuentaPunitorios: [],
    totalItemsCuentaPunitorios: 0,
  }),
  created() {
    this.loadSucursales();
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    /*  show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }, */
    listCreditosActivos: function () {
      if (!this.listDeudas || this.listDeudas.length == 0) return [];
      let lista = this.listDeudas.filter(
        (i) => i.tipo == 'Credito' || i.tipo == 'Acuerdo'
      );

      return lista;
    },
    totalAAplicar: function () {
      return (
        (this.aplicacionCapital
          ? parseFloat(this.aplicacionCapital)
          : parseFloat(0)) +
        (this.aplicacionInteres
          ? parseFloat(this.aplicacionInteres)
          : parseFloat(0)) +
        (this.aplicacionCargo1
          ? parseFloat(this.aplicacionCargo1)
          : parseFloat(0)) +
        (this.aplicacionCargo2
          ? parseFloat(this.aplicacionCargo2)
          : parseFloat(0)) +
        (this.aplicacionCargo3
          ? parseFloat(this.aplicacionCargo3)
          : parseFloat(0)) +
        (this.aplicacionCargo4
          ? parseFloat(this.aplicacionCargo4)
          : parseFloat(0)) +
        (this.aplicacionCargo5
          ? parseFloat(this.aplicacionCargo5)
          : parseFloat(0)) +
        (this.aplicacionPunitorios
          ? parseFloat(this.aplicacionPunitorios)
          : parseFloat(0))
      );
    },
    totalABonificar: function () {
      if (!this.listDeudasABonificar || this.listDeudasABonificar.length == 0)
        return 0;

      var total = 0;
      for (let index = 0; index < this.listDeudasABonificar.length; index++) {
        total =
          total + parseFloat(this.listDeudasABonificar[index].totalAAplicar);
      }
      return total;
    },
    creditoSeleccionado: function () {
      if (!this.creditoSeleccionadoId) return null;
      return this.listDeudas.find((d) => d.id == this.creditoSeleccionadoId);
    },
  },
  filters: {
    formatDate: function (value) {
      if (value) return format(value, 'DD-MM-YYYY');
    },
    formatMoney: function (value) {
      if (value) {
        if (Number.isInteger(value)) return '$ ' + value + '.00';
        else return '$ ' + value;
      }
    },
  },
  watch: {
    /* visible: function(){
            if(this.visible){
                this.showId = false
                this.loadDatosPersona();
            }
        }, */
    realizarQuitaPor: function () {
      this.listDeudasABonificar = [];
      if (this.realizarQuitaPor == 'cuota') {
        this.aplicacionCapital = null;
        this.aplicacionInteres = null;
        this.aplicacionCargo1 = null;
        this.aplicacionCargo2 = null;
        this.aplicacionCargo3 = null;
        this.aplicacionCargo4 = null;
        this.aplicacionCargo5 = null;
        this.aplicacionPunitorios = null;
        this.comentarios = '';
      } else if (this.realizarQuitaPor == 'importe') {
        this.aplicacionCapital = 0;
        this.aplicacionInteres = 0;
        this.aplicacionCargo1 = 0;
        this.aplicacionCargo2 = 0;
        this.aplicacionCargo3 = 0;
        this.aplicacionCargo4 = 0;
        this.aplicacionCargo5 = 0;
        this.comentarios = '';
      } else if (this.realizarQuitaPor == 'punitorios') {
        this.aplicacionPunitorios = 0;
        this.aplicacionCapital = null;
        this.aplicacionInteres = null;
        this.aplicacionCargo1 = null;
        this.aplicacionCargo2 = null;
        this.aplicacionCargo3 = null;
        this.aplicacionCargo4 = null;
        this.aplicacionCargo5 = null;
        this.comentarios = '';
        this.verCuentaPunitorios();
      }
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    limpiar: function () {
      this.selectedPersona = null;
      this.creditoSeleccionadoId = null;
      this.listDeudasABonificar = [];
    },
    setPersona(persona) {
      this.selectedPersona = persona;
      this.personaId = persona.personaId;
      this.loadDeudas();
    },
    async loadDeudas() {
      this.listDeudas = [];
      this.loadingDeudas = true;
      try {
        var result = await http.get(
          'personas/listdeudasporcobrardetallada' +
            '?empresaId=0' +
            '&id=' +
            this.personaId +
            '&fechaCaja=' +
            format(new Date(), 'YYYY-MM-DD')
        );

        this.listDeudas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingDeudas = false;
    },
    async verCuentaPunitorios() {
      // cargo la cta de punitorios
      this.loading = true;
      try {
        var result = await http.get(
          'creditos/listcuentacorrientepunitorios?creditoId=' +
            this.creditoSeleccionado.id
        );
        //console.log(result.list)

        this.cuentaPunitorios = result.list;
        this.totalItemsCuentaPunitorios = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    isExpandedDetalleCredito: function (item) {
      if (!item || !this.creditoSeleccionadoId || !this.showDetalleCredito)
        return false;

      if (item.id == this.creditoSeleccionadoId) return true;
      else return false;
    },
    agregarCuotaCredito(creditoId, item) {
      // agrego hasta la cuota seleccionada mas todas las anteriores
      var listaAAgregar = this.listCreditosActivos
        .find((d) => d.id == creditoId)
        .detalle.filter((i) => i.cuota <= item.cuota);

      var credito = this.listCreditosActivos.find((d) => d.id == creditoId);

      for (let index = 0; index < listaAAgregar.length; index++) {
        const el = listaAAgregar[index];

        // veo que ya no esté incluido
        if (this.listDeudasABonificar.find((i) => i.cuotaId == el.id) != null)
          continue;

        this.addCuota(
          /*'Credito', */ creditoId,
          credito.numero,
          el,
          el.importeCapital,
          el.importeInteres,
          el.importeCargo1,
          el.importeCargo2,
          el.importeCargo3,
          el.importeCargo4,
          el.importeCargo5,
          0
        );
      }
    },
    addCuota(
      /*tipo, */ id,
      numero,
      item,
      aplicaCapital,
      aplicaInteres,
      aplicaCargo1,
      aplicaCargo2,
      aplicaCargo3,
      aplicaCargo4,
      aplicaCargo5,
      aplicaPunitorios
    ) {
      var toAdd = {};
      //toAdd.tipo = 'Credito';
      toAdd.numero = numero;
      toAdd.id = id;
      toAdd.cuotaId = item.id;
      toAdd.cuota = item.cuota;
      toAdd.item = item;
      /* toAdd.importeAAplicarACuota = aplicaCuota;
        toAdd.importeAAplicarAPunitorios = aplicaPunitorios;
        toAdd.importeAAplicarACargos = aplicaCargos; */
      toAdd.importeAAplicarACapital = aplicaCapital;
      toAdd.importeAAplicarAInteres = aplicaInteres;
      toAdd.importeAAplicarACargo1 = aplicaCargo1;
      toAdd.importeAAplicarACargo2 = aplicaCargo2;
      toAdd.importeAAplicarACargo3 = aplicaCargo3;
      toAdd.importeAAplicarACargo4 = aplicaCargo4;
      toAdd.importeAAplicarACargo5 = aplicaCargo5;
      toAdd.importeAAplicarAPunitorios = aplicaPunitorios;

      toAdd.totalAAplicar =
        parseFloat(toAdd.importeAAplicarACapital) +
        parseFloat(toAdd.importeAAplicarAInteres) +
        parseFloat(toAdd.importeAAplicarACargo1) +
        parseFloat(toAdd.importeAAplicarACargo2) +
        parseFloat(toAdd.importeAAplicarACargo3) +
        parseFloat(toAdd.importeAAplicarACargo4) +
        parseFloat(toAdd.importeAAplicarACargo5) +
        parseFloat(toAdd.importeAAplicarAPunitorios);

      this.listDeudasABonificar.push(toAdd);
    },
    quitarCuota(creditoId, item) {
      // si el concepto es de una cuota de crédito, quito de la seleccinada para adelante
      var listaAQuitar = this.listDeudasABonificar.filter(
        (d) => d.id == creditoId && d.item.cuota >= item.cuota
      );
      var indexToRemove = this.listDeudasABonificar
        .map((x) => x.cuotaId)
        .indexOf(item.id);

      this.listDeudasABonificar.splice(indexToRemove, listaAQuitar.length);
    },
    async altaNotaCredito() {
      if (!this.validarAlta()) return;

      var params = {};
      params.creditoId = this.creditoSeleccionadoId;
      params.personaId = this.personaId;
      params.sucursalId = this.sucursalId;
      params.fecha = this.fecha;
      params.esFiscal = false;
      params.detalle = this.listDeudasABonificar;
      params.comentarios = this.comentarios;
      params.importeTotal = this.totalABonificar;
      params.esQuitaPunitorios = this.realizarQuitaPor == 'punitorios';
      params.esBotonDeArrepentimiento = this.esBotonDeArrepentimiento;
      try {
        this.saving = true;
        await http.post(
          'comprobantes/altanotacredito',
          JSON.stringify({ parametros: params })
        );

        this.alertSuccess('Se ha generado la quita.');
        this.limpiar();
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = false;
    },
    async validarQuitaPorImporte() {
      if (!this.creditoSeleccionadoId) {
        this.alertWarning('Debe elegir un crédito.');
        return;
      }

      // al agregar x monto, quito los conceptos que pueda haber anteriormente para el crédito
      var listaCuotasABorrar = this.listDeudasABonificar.filter(
        (d) => d.id == creditoId
      );
      if (listaCuotasABorrar.length > 0)
        this.quitarCuota(listaCuotasABorrar[0]);

      var porAplicarACapital = parseFloat(this.aplicacionCapital);
      var porAplicarAInteres = parseFloat(this.aplicacionInteres);
      var porAplicarACargo1 = parseFloat(this.aplicacionCargo1);
      var porAplicarACargo2 = parseFloat(this.aplicacionCargo2);
      var porAplicarACargo3 = parseFloat(this.aplicacionCargo3);
      var porAplicarACargo4 = parseFloat(this.aplicacionCargo4);
      var porAplicarACargo5 = parseFloat(this.aplicacionCargo5);
      var porAplicarAPunitorios = parseFloat(this.aplicacionPunitorios);

      const creditoId = this.creditoSeleccionadoId;

      var credito = this.listCreditosActivos.find((d) => d.id == creditoId);
      var cuotas = this.listCreditosActivos.find(
        (d) => d.id == creditoId
      ).detalle;

      this.loading = true;
      try {
        var result = await http.put(
          'businesscore/distribuirimportedetalladoacuotascredito',
          JSON.stringify({
            importeAAplicarCapital: porAplicarACapital,
            importeAAplicarInteres: porAplicarAInteres,
            importeAAplicarCargo1: porAplicarACargo1,
            importeAAplicarCargo2: porAplicarACargo2,
            importeAAplicarCargo3: porAplicarACargo3,
            importeAAplicarCargo4: porAplicarACargo4,
            importeAAplicarCargo5: porAplicarACargo5,
            importeAAplicarPunitorios: porAplicarAPunitorios,
            cuotasAdeudadas: cuotas,
          })
        );

        if (result.length > 0) {
          for (let index = 0; index < result.length; index++) {
            const el = result[index];
            //const item = cuotas.find(c=>c.id == el.id);

            this.addCuota(
              /*'Credito',*/ creditoId,
              credito.numero,
              el,
              el.importeAplicadoCapital,
              el.importeAplicadoInteres,
              el.importeAplicadoCargo1,
              el.importeAplicadoCargo2,
              el.importeAplicadoCargo3,
              el.importeAplicadoCargo4,
              el.importeAplicadoCargo5,
              el.importeAplicadoPunitorios
            );
          }
          this.loading = false;

          return true;
        } else {
          this.alertWarning(
            'No se pudo distribuir el monto ingresado entre los conceptos adeudados. Verifique'
          );
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
      return false;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    validarAlta() {
      if (!this.personaId) {
        this.alertWarning('Debe elegir una persona.');
        return false;
      }

      if (!this.creditoSeleccionadoId) {
        this.alertWarning('Debe elegir un crédito.');
        return false;
      }

      if (!this.sucursalId) {
        this.alertWarning('Debe elegir una sucursal.');
        return false;
      }

      if (!this.fecha) {
        this.alertWarning('Debe ingresar la fecha del comprobante.');
        return false;
      }

      if (!this.listDeudasABonificar || this.listDeudasABonificar.length == 0) {
        this.alertWarning('Debe elegir los conceptos a bonificar.');
        return false;
      }

      return true;
    },
  },
};
</script>
